import React, { useMemo } from 'react';
import i18next from 'i18next';

import * as routes from '../navigation/routes.constants';
import { LANGUAGES_FR_CA } from '../../i18n';

import styles from './FooterLinks.module.css';

const DO_NOT_SELL_REF = '#';

const FooterLinks = ({
  className = '',
  doNotSellLabel,
  privacyLabel,
  termsLabel,
}) => {
  const privacyLink = useMemo(
    () => (i18next.language === LANGUAGES_FR_CA
      ? routes.VIE_PRIVEE : routes.PRIVACY_POLICY),
    [i18next.language],
  );

  const onDoNotSellClick = (event) => {
    event.preventDefault();
    window.Osano?.cm?.showDoNotSell();
  };

  return (
    <div className={`${styles.linksRow} ${className}`}>
      <a
        className={styles.footerLink}
        href={privacyLink}
        rel="noopener noreferrer"
        target="_blank"
      >
        {privacyLabel}
      </a>

      <a
        className={styles.footerLink}
        href={routes.TERMS_OF_USE}
        rel="noopener noreferrer"
        target="_blank"
      >
        {termsLabel}
      </a>

      <a
        className={styles.footerLink}
        href={DO_NOT_SELL_REF}
        onClick={onDoNotSellClick}
        rel="noopener noreferrer"
        target="_blank"
      >
        {doNotSellLabel}
      </a>
    </div>
  );
};

export { FooterLinks };
